<template>
  <Card class="octadesk-kb--card">
    <div class="kb-card--search--container">
      <div class="kb-card--search--input--container">
        <input
          v-model="searchTerm"
          type="text"
          :placeholder="$t('kbCard.inputPlaceholder')"
          @keyup="handleSearch()"
        />

        <span class="kb-card--search--input--icon">
          <svg width="18px" height="18px" viewBox="0 0 18 18">
            <use xlink:href="#icon-search"></use>
          </svg>
        </span>
      </div>
    </div>

    <div class="kb-card--search--result">
      <div v-if="!currentArticle && !isCurrentArticleLoading">
        <p v-if="kbSearchLoader" class="kb-card--subtitle busy">
          {{ $t('kbCard.loaderMessage') }}
        </p>

        <p v-else class="kb-card--subtitle">{{ searchResultText }}</p>
      </div>

      <div v-if="isCurrentArticleLoading" class="kb-card--article">
        <div class="kb-card--article--container">
          <div class="kb-card--article--title">
            <div class="kb-card--article--fake-title"></div>
          </div>

          <div class="kb-card--article--body">
            <div
              v-for="row in 8"
              :key="row"
              class="kb-card--article--fake-row"
            ></div>
          </div>
        </div>
      </div>

      <div
        v-if="currentArticle && !isCurrentArticleLoading"
        class="kb-card--article"
      >
        <div class="kb-card--article--container">
          <div class="kb-card--article--title">
            {{ currentArticle ? currentArticle.title : '' }}
          </div>

          <div
            class="kb-card--article--body"
            v-html="currentArticle ? currentArticle.content : ''"
          ></div>
        </div>

        <button
          type="button"
          class="kb-card--article--back-btn oct-btn-secondary"
          :style="`border-color: rgb(${settings.bgColorRGB}); color: rgb(${settings.bgColorRGB});`"
          @click="handleBackFromArticle()"
        >
          {{ $t('kbCard.buttonBack') }}
        </button>
      </div>

      <div
        class="kb-card--articles--container"
        :class="{
          show: !currentArticle && !isCurrentArticleLoading
        }"
      >
        <div v-if="!kbTyping">
          <div
            v-for="article in articles"
            :key="article.lastUpdate"
            class="kb-card--articles--item"
          >
            <a
              class="no-decoration"
              :href="getArticleUrl(article.url)"
              target="_system"
              @click.prevent="handleOpenArticle(article.url)"
            >
              <p>
                <i class="kb-card--articles--item--icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="10.927"
                    height="10.352"
                    viewBox="0 0 10.927 10.352"
                  >
                    <use xlink:href="#icon--kb--item"></use>
                  </svg>
                </i>

                <span>{{ article.title }}</span>
              </p>
            </a>
          </div>
        </div>

        <div v-if="kbSearchLoader">
          <div
            v-for="index in 7"
            :key="index"
            class="kb-card--articles--item kb-card--articles--item-fake"
          >
            <a class="no-decoration">
              <p>
                <i class="kb-card--articles--item--icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="10.927"
                    height="10.352"
                    viewBox="0 0 10.927 10.352"
                  >
                    <use xlink:href="#icon--kb--item"></use>
                  </svg>
                </i>

                <i class="kb-card--articles--item--fake-text--wrapper">
                  <i class="kb-card--articles--item--fake-text"></i>

                  <i class="kb-card--articles--item--fake-text"></i>
                </i>
              </p>
            </a>
          </div>
        </div>

        <div
          v-if="articlesHasMore && !kbSearchLoader"
          class="kb-card--pagination"
        >
          <button
            class="kb-card--pagination--button oct-btn-secondary"
            :style="`border-color: rgb(${settings.bgColorRGB}); color: rgb(${settings.bgColorRGB});`"
            @click="handleLoadMore"
          >
            {{ $t('kbCard.loadMore') }}
          </button>
        </div>
      </div>
    </div>

    <div class="kb-card--cta">
      <button
        :style="`background-color: rgb(${settings.bgColorRGB}); color: rgba(${settings.fontColorRGBA});`"
        class="octadesk-button kb-card--cta"
        @click="handleCta"
      >
        {{ ctaText }}
      </button>
    </div>
  </Card>
</template>

<script>
  // OBSOLETE: Remove this component to new version without ticket
  import { mapGetters, mapActions } from 'vuex'

  import services from '@/services'

  import Card from '@/app/components/Card'

  export default {
    components: {
      Card
    },
    data() {
      return {
        searchTerm: '',
        searching: false,
        kbSearchingTimeout: undefined,
        searched: false
      }
    },
    computed: {
      ...mapGetters([
        'articles',
        'articlesHasMore',
        'flux',
        'kbTyping',
        'kbSearchLoader',
        'kbSearchResult',
        'articlesTotal',
        'articlesCount',
        'flux',
        'active',
        'settings',
        'currentArticle',
        'isCurrentArticleLoading'
      ]),
      title() {
        return this.flux && this.flux.kb ? this.flux.kb.title : undefined
      },
      searchResultText() {
        return this.searched && this.searchTerm
          ? this.$t('kbCard.searchResult')
          : this.$t('kbCard.searchRecents')
      },
      ctaText() {
        return this.$t('kbCard.buttonSend')
      }
    },
    async mounted() {
      if (this.active) {
        try {
          await this.findArticles()
        } catch (err) {
          console.error(err)
        }

        this.setKbLoader(false)

        this.setKbTyping(false)
      }
    },
    methods: {
      ...mapActions([
        'findArticles',
        'moreArticles',
        'searchArticles',
        'setKbTyping',
        'setKbLoader',
        'setKbSearchResult',
        'includeChatArticle',
        'updateActivity',
        'setCurrentArticle',
        'setIsCurrentArticleLoading'
      ]),
      async handleLoadMore() {
        this.setKbLoader(true)
        try {
          await this.moreArticles()
        } catch (err) {
          console.error(err)
        }

        this.setKbLoader(false)
      },
      handleSearch() {
        this.setKbTyping(true)

        this.setKbLoader(true)

        this.searched = true

        if (this.currentArticle) {
          this.setCurrentArticle(null)
        }

        if (this.kbSearchingTimeout) {
          clearTimeout(this.kbSearchingTimeout)
        }

        this.kbSearchingTimeout = setTimeout(() => {
          if (!this.kbSearching && this.searchTerm) {
            this.searching = true

            this.handleSearchArticles()
          } else {
            this.getDefaultArticles()
          }
        }, 500)
      },
      handleSearchArticles() {
        this.searching = true

        this.searchArticles(this.searchTerm)
          .then(() => {
            this.searching = false

            this.setKbTyping(false)

            this.setKbLoader(false)

            this.setKbSearchResult(this.articlesCount)

            if (this.articlesCount === 0) {
              this.getDefaultArticles()
            }
          })
          .catch(() => {
            this.kbSearching = false

            this.setKbTyping(false)

            this.setKbLoader(false)
          })
      },
      getDefaultArticles() {
        this.setKbLoader(true)

        this.setKbSearchResult(0)

        this.findArticles()
          .then(() => {
            this.setKbLoader(false)

            this.setKbTyping(false)
          })
          .catch(() => {
            this.setKbLoader(false)

            this.setKbTyping(false)
          })
      },
      handleCta() {
        this.$emit('cta')
      },
      getArticleUrl(articleUrl) {
        return `${services.main.getBaseUrl()}/kb/article/${articleUrl}`
      },
      async handleOpenArticle(url) {
        this.setIsCurrentArticleLoading(true)

        try {
          await this.setCurrentArticle(url)
        } catch (err) {
          console.error(err)
        }

        this.setIsCurrentArticleLoading(false)
      },
      handleBackFromArticle() {
        this.setCurrentArticle(null)
      }
    }
  }
</script>

<style>
  @import url('https://fonts.googleapis.com/css2?family=Gloria+Hallelujah&display=swap');

  .octadesk-kb--card {
    background: #fff;
    margin: 0 16px;
    margin-top: -16px;
    padding: 17px;
    padding-bottom: 2rem;
    position: absolute;
    width: calc(100% - 32px);
  }

  .kb-card--title {
    font-family: 'Gloria Hallelujah', cursive;
    font-size: 25px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.04;
    letter-spacing: normal;
    text-align: center;
    color: #484848;
  }

  .kb-card--subtitle {
    font-family: Roboto;
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #5c5d5e;
    padding: 0.5rem 0.6rem;
  }

  .kb-card--subtitle.busy {
    color: #b9b9b9;
  }

  .kb-card--search--input--container {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .kb-card--search--input--icon {
    color: #000;
    position: absolute;
    right: 1rem;
    top: 50%;
    transform: translateY(-50%);
  }

  .kb-card--search--input--container input {
    border-radius: 6px;
    border: none;
    background: #f6f6f6;
    height: 41px;
    padding-left: 0.7rem;
    padding-right: 45px;
    width: 100%;
    font-size: 0.875rem;
    color: #757575;
  }

  .kb-card--search--input--container button {
    width: 47px;
    height: 41px;
    border-radius: 11px;
    color: #fff;
    margin-left: -10px;
    cursor: pointer;
  }

  .kb-card--search--result {
    height: 100%;
  }

  .kb-card--pagination {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 1.25rem;
    margin-bottom: 0.15rem;
  }

  .oct-btn-secondary {
    cursor: pointer;
    background-color: transparent !important;
    border-radius: 20px;
    padding: 0.3rem 0.6rem;
    font-size: 12px;
    border: solid 1px transparent;
  }

  .kb-card--pagination--button {
    margin-left: 11px;
  }

  .kb-card--articles--container {
    list-style-type: none;
    margin: 0;
    max-height: calc(100% - 88px);
    overflow: auto;
    padding: 0;
    opacity: 0;
    pointer-events: none;
  }

  .kb-card--articles--container.show {
    transition: opacity 600ms 100ms;
    opacity: 1;
    pointer-events: all;
  }

  .kb-card--articles--item {
    cursor: pointer;
  }

  .kb-card--articles--item--icon {
    margin-right: 0.5rem;
    line-height: 0.85rem;
  }

  .kb-card--articles--item--fake-text--wrapper {
    display: inline-block;
    width: calc(100% - 24px);
  }

  .kb-card--articles--item--fake-text {
    background-color: #e0e0e0;
    height: 17px;
    margin-right: 5px;
    display: block;
  }

  .kb-card--articles--item--fake-text:last-child {
    width: 50%;
    margin-top: 3px;
  }

  .kb-card--articles--item p {
    font-family: Roboto;
    font-size: 0.815rem;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    color: #333333;
    padding: 0.969rem 0.5rem;
    display: flex;
    align-items: flex-start;
    margin: 0 3px 0 3px;
    transition: all 300ms;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    border-top: 1px solid transparent;
    min-height: 63px;
  }

  .kb-card--articles--item:first-child p {
    border-top-color: rgba(0, 0, 0, 0.1);
  }

  .kb-card--articles--item-fake:first-child p {
    border-top-color: transparent;
  }

  .kb-card--articles--item:not(.kb-card--articles--item-fake):hover p {
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.3);
    border-bottom-color: transparent;
    border-radius: 3px;
  }

  .kb-card--articles--item-fake {
    cursor: default;
  }

  .kb-card--cta {
    width: 136px;
    padding: 0.6rem 0.6rem 0.6rem 1rem;
    position: absolute;
    bottom: -8px;
    left: calc(50% - 68px);
  }

  .kb-card--article {
    height: calc(100% - 60px - 0.5rem);
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }

  .kb-card--article--container {
    overflow-y: auto;
    max-height: 100%;
    min-height: 100%;
    margin-bottom: 0.5rem;
    width: 100%;
    padding-top: 2rem;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .kb-card--article--container p {
    margin: 0;
  }

  .kb-card--article--title {
    font-size: 1.1rem;
    padding-right: 4px;
    margin-bottom: 1rem;
  }

  .kb-card--article--back-btn {
    display: flex;
    align-self: center;
  }

  .kb-card--article--fake-title {
    background-color: #e0e0e0;
    height: 21px;
    margin-right: -4px;
    margin-bottom: 1rem;
  }

  .kb-card--article--fake-row {
    background-color: #e0e0e0;
    height: 17px;
  }

  .kb-card--article--fake-row + .kb-card--article--fake-row {
    margin-top: 0.6rem;
  }

  .kb-card--article--fake-row:nth-child(2n + 3) {
    width: 50%;
    animation-duration: 10s;
  }
</style>
